const styles = {
  otpModalStyle: {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
      position: "absolute",
      // top: "40px",
      // left: "40px",
      // right: "40px",
      // bottom: "40px",
      border: "1px solid #ccc",
      background: "#fff",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      borderRadius: "8px",
      outline: "none",
      padding: "20px",
      maxWidth: "600px",
      minHeight: "340px",
      maxHeight: "480px",
      margin: "auto"
    }
  }
};

export default styles;
